<template>
    <span class="server-group" v-tooltip="'ID grupy: ' + groups.sgid">
        <img v-if="groups.icon"  class="server-group-icon" ref="groupImg" :src="prefix + '/assets/groupIcons/' + groups.icon + '.png'">
        <font-awesome-icon v-else data-toggle="tooltip" :title='groups.name' class="server-group-icon" icon="image" style="margin-bottom: 0px;"/>
        <span v-if="withName">{{ groups.name }}</span>
    </span>
</template>

<script>
    export default {
        name: 'ServerGroups',
        props: {
            groups: [Object, Array],
            withName: Boolean,
        },
        computed: {
            prefix() {
                return process.env.NODE_ENV !== 'development' ? '' : 'http://51.75.37.170:2000';
            }
        }
    }
</script>

<style>
    .server-group-icon {
        width: 24px;
        height: 24px;
        margin: 5px;
    }
</style>